import { render, staticRenderFns } from "./zwDialog.vue?vue&type=template&id=1146a8c2"
import script from "./zwDialog.vue?vue&type=script&lang=js"
export * from "./zwDialog.vue?vue&type=script&lang=js"
import style0 from "./zwDialog.vue?vue&type=style&index=0&id=1146a8c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports